export const getBatonBaseUrl = (env) => (!env || env === 'prd' ? 'https://baton.fi.cimpress.io' : 'https://int-baton.fi.cimpress.io');
export const getOrderMangerBaseUrl = (env) => (!env || env === 'prd' ? 'https://order-manager.commerce.cimpress.io' : 'https://int-order-manager.commerce.cimpress.io');
